// extracted by mini-css-extract-plugin
export default {"editPostContainer":"EditSinglePost_editPostContainer__XoioP","customSelectNew":"EditSinglePost_customSelectNew__7GVO1","quill":"EditSinglePost_quill__0rX4L"};